import { List, Text } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { assertUnreachable } from 'src/lib/assertUnreachable';

import { LaunchesListInfo } from './helpers/computeLaunchesListInfo';
import { LaunchesListItem } from './LaunchesListItem/LaunchesListItem';

export const LaunchesListHeader = ({
  kindOfStep,
}: {
  kindOfStep: LaunchesListInfo['kind'];
}) => (
  <Text variant="label">
    {kindOfStep === 'build'
      ? 'Downstream builds'
      : kindOfStep === 'launch'
        ? 'Downstream launches'
        : kindOfStep === 'supersede'
          ? 'Superseding launch'
          : assertUnreachable(kindOfStep)}
  </Text>
);

type Props = {
  launchesInfo: LaunchesListInfo;
  linkLaunches?: boolean;
  className?: string;
};

export const LaunchesList = ({
  launchesInfo: { kind, launches },
  linkLaunches,
  className,
}: Props) => {
  if (launches.length === 0) return null;

  return (
    <div className={classnames(className, 'flex flex-col items-start')}>
      <LaunchesListHeader kindOfStep={kind} />
      <List isInteractive className="mt-2">
        {launches.map(({ launch, status, progress, isStarted }) => (
          <LaunchesListItem
            key={launch.id}
            kind={kind}
            launchInfo={{ launch, status, progress, isStarted }}
            linkLaunch={linkLaunches}
          />
        ))}
      </List>
    </div>
  );
};
